export enum PriorityServiceEnum {
    BAIXA = "baixa",
    MEDIA = "media",
    ALTA = "alta",
    URGENTE = "urgente",
}